// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"641e9b9b","408":"010e53b6","453":"bad29332"}[chunkId] + ".chunk.js";
};